import { render, staticRenderFns } from "./detailPractice.vue?vue&type=template&id=46d844a4&"
import script from "./detailPractice.vue?vue&type=script&lang=js&"
export * from "./detailPractice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports